import { useEffect, useRef, useState, useMemo } from "react";
import { useAudio } from "../Contexts/AudiosContext";
import AudioService from "../Services/AudioPlayer";
import closeimg from "../Images/close-C.png";
import mni from "../Images/minimize-C.png";
import arrowleft from "../assets/img/arrowleft.png"
import gitalogoMain from "../assets/img/logo_Main.png"
import AudioLyrics from "../Components/AudioLyrics";
import AudioSeo from "../Components/AudioSeo";
import i18n, { _get_i18Lang } from "../i18n";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import WithoutLyrics from "../Images/audiolyrics.svg";
import WithLyrics from "../Images/audiowithoutlyrics.svg";
import Play from "../Images/songPlay.svg";
import Pause from "../assets/audioPlayer/img/bgorangepause.svg";
import { LogInModel } from "./LoginModel";

const AudioPlayerPage = ({ match }: any) => {
  console.log("AudioPlayerPage Render ->", { match });
  const navigate = useNavigate();

  const {
    // isMin,
    // setMin,
    setAudiosList,
    setIsMinismise,
    audiosList,
    playAudio,
    currentAudio,
    close,
    showList,
    playingAudio,
    setPlayingAudio,
  } = useAudio();

  const location = useLocation();
  const { t } = useTranslation();
  const state = location.state as {
    audioId: string;
    sorting: string;
    index: number;
    audiocat: string;
    audioAuthor: string,
    title: string,
    audioslug: string,
    pageNum: number,
    otherpreacher: boolean
  };

  const catId = useRef<string | any>(state?.audiocat! || "");
  const auid = useRef<string | undefined>(state?.audioId! || "");

  const [Type, setType] = useState<any | undefined>(
    localStorage.getItem("type")
  );

  // Determine audio type from URL path for SEO
  const audioType = useMemo(() => {
    const pathType = location.pathname.split('/')[1]?.toLowerCase();
    if (pathType === 'pravachans') return 'pravachans';
    if (pathType === 'dailysatsang') return 'DailySatsang';
    return 'audios';
  }, [location.pathname]);

  // Build canonical path for SEO
  const canonicalPath = useMemo(() => {
    if (currentAudio?.slug) {
      return `/${audioType}/${currentAudio.slug}`;
    }
    return location.pathname;
  }, [audioType, currentAudio?.slug, location.pathname]);

  const [logIn, setLogIn] = useState<boolean>(false);

  const closeModal = () => {
    setLogIn(false);
    navigate(-1)
  };

  const handleLoginStateChange = async (newState: any) => {
    console.log("AudioPlayerPage -> handleLoginStateChange -> loggedIn state:", newState);
  };

  function getPaginationRange(pageNumber: any, itemsPerPage: any) {
    // Ensure both values are valid positive integers
    if (!Number.isInteger(pageNumber) || pageNumber <= 1) {
      return { start: 0, length: Math.max(0, itemsPerPage) };
    }

    if (!Number.isInteger(itemsPerPage) || itemsPerPage <= 0) {
      return { start: 0, length: 0 };
    }

    const start = (pageNumber - 1) * itemsPerPage;
    const length = itemsPerPage;

    return { start, length };
  }

  // Example usage:
  const pageNumber = state?.pageNum;
  const itemsPerPage = 12;
  const { start, length } = getPaginationRange(pageNumber, itemsPerPage);

  useEffect(() => {
    console.log("AudioPlayerPage useEffect(trigger) -> state:", state, "auid:", auid.current, "catId:", catId.current, "Type:", Type);

    // If the URL is a raw ObjectId (direct visit) and there is NO navigation state,
    // do not fetch/play here — let App.tsx resolve id -> slug and navigate.

    const hasNavStateAudio = !!(location.state && (location.state as any).audioId);
    if (!hasNavStateAudio) {
      console.log("AudioPlayerPage: raw id in URL and no navigation state — skipping load and waiting for App to resolve slug");
      return;
    }

    if (localStorage.getItem("Token")) {
      console.log("AudioPlayerPage: Token found - starting to load audio list with AudioPlayer.getAudioPlayer");
      setType(localStorage.getItem("type"));
      // If no type is stored in localStorage, fallback to first segment of path (e.g. '/audios/...')
      var pathname = location.pathname.split('/')[1]
      if (!localStorage.getItem("type") && localStorage.getItem("type") == null) {
        setType(pathname);
        localStorage.setItem("type", pathname);
        let Type = pathname;
      }
      console.log("AudioPlayerPage: Current Type: " + Type);

      AudioService.getAudiosList(
        _get_i18Lang(),
        start,
        length,
        false,
        state?.audiocat || "",
        state?.audioAuthor || "",
        "",
        state?.sorting! || "",
        "",
        false,
        (!Type || Type === "null") ? pathname : Type,
        // state?.otherpreacher
        // window?.location.pathname === "/audio" ? "audios" : "pravachans",
      ).then((res) => {
        console.log("AudioPlayerPage -> getAudioPlayer result:", res);
        if (res?.status) {
          // debugger
          // console.log("sates in audio player page", location);

          setIsMinismise(false);
          // setMin(false)
          // state?.audioAuthor ? 
          console.log("AudioPlayerPage -> Setting audios list and starting play for:", { id: state?.audioId, index: state?.index, slug: state?.audioslug });
          setAudiosList(res.result.items)
          //  : setAudiosList(initialArray)
          playAudio(state?.audioId!, state?.index, state?.audioslug);
          // const element = document.getElementById(state?.audioId);
          const element = document.getElementById(state?.title)
          element?.scrollIntoView();
        }
      }).catch((err) => {
        console.error("AudioPlayerPage -> getAudioPlayer error:", err);
      })
    } else {
      setLogIn(true);
      console.log("AudioPlayerPage: No Token - opened login modal");
    }
  }, [auid, i18n.language, catId, Type]);

  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    const handleResize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
      console.log("AudioPlayerPage -> resize -> new size:", { width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="">
      {/* SEO Component for Audio Player Page */}
      <AudioSeo
        audio={currentAudio}
        canonicalPath={canonicalPath}
        type={audioType}
      />
      <div
        className="row bgimage"
        style={{
          borderBottomColor: "black",
          marginRight: "0px",
          // width: size.width, height: size.height
        }}
      >
        <div
          className="col-xl-3 col-lg-4"
          style={{ display: "block" }}
        >
          <div className="songSidebar">
            <div className="ralated-logo">
              <button
                type="button"
                title="back"
                aria-label="Back"
                onClick={() => {
                  navigate(`/${Type}`)
                  setIsMinismise(true);
                }}
                style={{ padding: "5px", background: "transparent", border: "none", cursor: "pointer" }}
              >
                <img
                  alt="Back"
                  src={arrowleft}
                  style={{ verticalAlign: "top", margin: "10px", filter: "invert(100%)" }}
                  width="30"
                />
              </button>
              <img alt="GitaSeva Logo" src={gitalogoMain} />
            </div>
            <div className="relatedaudiotitle">
              {t("Related_audios_tr")}
            </div>
            <div className="songCategories">
              {audiosList.map((a, i) => (
                <div key={a?.id}>
                  <div
                    id={a?.id}
                    style={{
                      height: "75px",
                      cursor: "pointer",
                      borderBottom: "1px solid #ebe8dd",
                      paddingTop: "5px",
                      overflow: "hidden",
                      display: "flex"
                    }}
                  >
                    <img
                      src={
                        a.id === currentAudio?.id
                          ? playingAudio
                            ? Play   // Show Pause icon if the current audio is playing
                            : Pause    // Show Play icon if the current audio is selected but paused
                          : a.lyricsHash === null || a.lyricsHash === undefined
                            ? WithoutLyrics
                            : WithLyrics
                      }
                      alt=""
                      width="19%"
                    />

                    <div
                      style={{ marginLeft: "10px" }}
                      // variant={a.id === currentAudio?.id ? "link" : "light"}
                      onClick={() => {
                        console.log("AudioPlayerPage -> clicked audio ->", { id: a.id, idx: i, slug: a.slug, name: a.name });
                        playAudio(a.id, i, a.slug);
                      }}
                    >
                      <p style={{
                        marginTop: a.author === "" || size.width < 1400 ? "15px" : "5px",
                        marginBottom: 0,
                        fontWeight: 600,
                        color: a.id === currentAudio?.id ? "#fd7e35 " : "#FFA80F",
                        paddingTop: "0px",
                        fontFamily: 'ChanakyaUni',
                        fontSize: '22px',
                        textAlign: "justify",
                        textDecoration: "none",
                        wordBreak: "break-all"
                      }}>
                        {a.name != null && a.name.length > 30
                          ? size.width > 1400 ? a.name.slice(0, 29) + "..." : a.name.slice(0, 27) + "..."
                          : a.name}
                      </p>
                      <p style={{ color: "#535353", margin: "0", fontSize: "18px", fontWeight: "400", fontFamily: 'ChanakyaUni' }}>
                        {a.author != null || undefined ? a.author : ""}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
          </div>
        </div>

        <div className="col-xl-9 col-lg-8 no-copy" style={{ padding: 0, margin: 0 }}>
          <div className="closeTab">
            <button
              type="button"
              aria-label="Minimize"
              style={{ background: "transparent", border: "none", padding: 0, margin: 0, cursor: "pointer" }}
              className="pe-sm-2"
              onClick={() => {
                console.log("AudioPlayerPage -> minimized via mni click -> navigate to:", Type);
                setIsMinismise(true);
                // setMin(true)
                // navigate(`/${Type}/`)
                navigate(`/${Type}`);
              }}
            >
              <img
                alt="Minimize"
                src={mni}
                style={{ marginLeft: "10px" }}
              />
            </button>

            <button
              type="button"
              aria-label="Close"
              style={{ background: "transparent", border: "none", padding: 0, margin: 0, cursor: "pointer" }}
              onClick={() => {
                console.log("AudioPlayerPage -> close clicked - closing audio and navigating to:", Type);
                close();
                navigate(`/${Type}`);
                setPlayingAudio(false);
                // navigate(-1)
              }}
            >
              <img
                alt="Close"
                src={closeimg}
              />
            </button>
          </div>
          <AudioLyrics />
        </div>
        <div className="responsive-footer full-bleed" role="contentinfo" aria-label="Responsive footer bar">
          <div className="inner">
            <span>यहाँ आपकी पूर्ण-चौड़ाई वाली बार है — ऊँचाई 55px (HD 1080p) के अनुरूप स्केल होती है</span>
          </div>
        </div>
      </div>
      <LogInModel opens={logIn} onCloses={closeModal} onLoginStateChange={handleLoginStateChange} />
    </div>
  );
};
export default AudioPlayerPage;